import { handleActions } from 'redux-actions'

import { showLoader, hideLoader } from './actions'

export const INITIAL_STATE = {
  loaderShown: false,
}

export default handleActions(
  {
    [showLoader]: () => ({ loaderShown: true }),
    [hideLoader]: () => ({ loaderShown: false }),
  },
  INITIAL_STATE,
)
